 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		78: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~js/admin-accounts~js/admin-accounts-transactions~js/admin-affiliate-commissions~js/admin-cha~6d015d10","1":"js/games/common","2":"js/admin-dashboard-affiliates~js/admin-dashboard-games~js/admin-dashboard-users~js/payments/admin-dashboard","3":"js/admin-accounts","4":"js/admin-add-ons","5":"js/admin-affiliate","6":"js/admin-affiliate-commissions","7":"js/admin-affiliate-tree","8":"js/admin-chat","9":"js/admin-chat-messages","10":"js/admin-chat-rooms","11":"js/admin-dashboard","12":"js/admin-games","13":"js/admin-license","14":"js/admin-maintenance","15":"js/admin-settings","16":"js/admin-users","17":"js/email","18":"js/games","19":"js/history","20":"js/pages","21":"js/user-affiliate","22":"js/user-security","23":"vendors~js/admin-affiliate-tree","24":"vendors~js/admin-settings","25":"js/2fa","26":"js/404","27":"js/503","28":"js/Squares","29":"js/Stars","30":"js/admin-accounts-credit","31":"js/admin-accounts-debit","32":"js/admin-accounts-show","33":"js/admin-accounts-transactions","34":"js/admin-add-ons-changelog","35":"js/admin-add-ons-install","36":"js/admin-affiliate-commissions-approve","37":"js/admin-affiliate-commissions-reject","38":"js/admin-affiliate-commissions-show","39":"js/admin-chat-messages-delete","40":"js/admin-chat-rooms-create","41":"js/admin-chat-rooms-delete","42":"js/admin-chat-rooms-edit","43":"js/admin-dashboard-affiliates","44":"js/admin-dashboard-games","45":"js/admin-dashboard-users","46":"js/admin-games-details","47":"js/admin-games-show","48":"js/admin-users-delete","49":"js/admin-users-edit","50":"js/admin-users-mail","51":"js/admin-users-show","52":"js/email-verify","53":"js/history-games-details","54":"js/history-games-show","55":"js/history-games-verify","56":"js/history-losses","57":"js/history-recent","58":"js/history-user","59":"js/history-wins","60":"js/leaderboard","61":"js/login","62":"js/offline","63":"js/password-email","64":"js/password-reset","65":"js/payments/admin-deposit-methods~js/payments/admin-withdrawal-methods","66":"js/register","67":"js/user-account-transactions","68":"js/user-affiliate-commissions","69":"js/user-affiliate-info","70":"js/user-affiliate-stats","71":"js/user-edit","72":"js/user-security-2fa","73":"js/user-security-password","74":"js/users-show","75":"vendors~js/games/dice-3d-resources-js-pages-game~js/games/heads-or-tails-resources-js-pages-game","76":"vendors~js/games/horse-racing-resources-js-pages-admin-settings~js/games/slots-resources-js-pages-ad~9f43b950","77":"vendors~js/payments/admin-withdrawals~js/payments/deposits","79":"js/games/american-roulette-resources-js-pages-admin-settings","80":"js/games/american-roulette-resources-js-pages-details","81":"js/games/american-roulette-resources-js-pages-game","82":"js/games/american-roulette-resources-js-pages-info","83":"js/games/baccarat-resources-js-pages-admin-settings","84":"js/games/baccarat-resources-js-pages-details","85":"js/games/baccarat-resources-js-pages-game","86":"js/games/baccarat-resources-js-pages-info","87":"js/games/blackjack-resources-js-pages-admin-settings","88":"js/games/blackjack-resources-js-pages-details","89":"js/games/blackjack-resources-js-pages-game","90":"js/games/blackjack-resources-js-pages-info","91":"js/games/casino-holdem-resources-js-pages-admin-settings","92":"js/games/casino-holdem-resources-js-pages-details","93":"js/games/casino-holdem-resources-js-pages-game","94":"js/games/casino-holdem-resources-js-pages-info","95":"js/games/dice-3d-resources-js-pages-admin-settings","96":"js/games/dice-3d-resources-js-pages-details","97":"js/games/dice-3d-resources-js-pages-game","98":"js/games/dice-3d-resources-js-pages-info","99":"js/games/dice-resources-js-pages-admin-settings","100":"js/games/dice-resources-js-pages-details","101":"js/games/dice-resources-js-pages-game","102":"js/games/dice-resources-js-pages-info","103":"js/games/european-roulette-resources-js-pages-admin-settings","104":"js/games/european-roulette-resources-js-pages-details","105":"js/games/european-roulette-resources-js-pages-game","106":"js/games/european-roulette-resources-js-pages-info","107":"js/games/heads-or-tails-resources-js-pages-admin-settings","108":"js/games/heads-or-tails-resources-js-pages-details","109":"js/games/heads-or-tails-resources-js-pages-game","110":"js/games/heads-or-tails-resources-js-pages-info","111":"js/games/horse-racing-resources-js-pages-admin-settings","112":"js/games/horse-racing-resources-js-pages-details","113":"js/games/horse-racing-resources-js-pages-game","114":"js/games/horse-racing-resources-js-pages-info","115":"js/games/lucky-wheel-resources-js-pages-admin-settings","116":"js/games/lucky-wheel-resources-js-pages-details","117":"js/games/lucky-wheel-resources-js-pages-game","118":"js/games/lucky-wheel-resources-js-pages-info","119":"js/games/multiplayer-blackjack-resources-js-pages-admin-settings","120":"js/games/multiplayer-blackjack-resources-js-pages-details","121":"js/games/multiplayer-blackjack-resources-js-pages-game","122":"js/games/multiplayer-blackjack-resources-js-pages-info","123":"js/games/payments-resources-js-pages-admin-settings","124":"js/games/raffle-resources-js-pages-admin-settings","125":"js/games/slots-resources-js-pages-admin-settings","126":"js/games/slots-resources-js-pages-details","127":"js/games/slots-resources-js-pages-game","128":"js/games/slots-resources-js-pages-info","129":"js/games/video-poker-resources-js-pages-admin-settings","130":"js/games/video-poker-resources-js-pages-details","131":"js/games/video-poker-resources-js-pages-game","132":"js/games/video-poker-resources-js-pages-info","133":"js/payments/admin-dashboard","134":"js/payments/admin-deposit-methods","135":"js/payments/admin-deposits","136":"js/payments/admin-withdrawal-methods","137":"js/payments/admin-withdrawals","138":"js/payments/deposits","139":"js/payments/withdrawals","140":"js/raffle/admin","141":"js/raffle/user","142":"vendors~js/games/baccarat-resources-js-pages-info","143":"vendors~js/games/blackjack-resources-js-pages-info","144":"vendors~js/games/casino-holdem-resources-js-pages-info","145":"vendors~js/games/dice-resources-js-pages-game","146":"vendors~js/games/video-poker-resources-js-pages-info"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
